module.exports = __webpack_public_path__ + "./fonts/bf9473ec00ff4c8b05bf40e19c067fad.woff2";